import Profile from "./pages/profile/Profile";
// import Home from "./pages/home/Home";

function App() {
  return <Profile />
}

export default App;